import { useEffect, useState } from "react";
import IPresenceOpenDTO from "../../../models/IPresenceOpenDTO";
import api from "../../../services/api";
import { authenticationService } from "../../../services/auth.service";
import { toast } from "react-toastify";
import toastOptions from "../../../utils/toastOptions";
import { Link, useNavigate } from "react-router-dom";
import { displayDateTime } from "../../../utils/masks";
import DialogConfirm from "../../../components/DialogConfirm";

interface PageParams {
  idEvent: number;
  nameEvent?: string;
}

export default function CheckInEvent(props: PageParams) {
  const { idEvent, nameEvent } = props;

  const [hasPresenceOpen, setPresenceOpen] = useState<boolean | undefined>(undefined);
  const [presenceOpened, setPresenceOpened] = useState<IPresenceOpenDTO>();
  const [isReadOnly, setReadOnly] = useState<boolean>(true);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [openConfirm, setConfirmeOpen] = useState<boolean>(false);
  const [label, setLabel] = useState<string>('Presenças');
  const navigate = useNavigate();

  useEffect(() => {
    setIsRunning(true);
    if (idEvent > 0) {
      init();
      setLabel(`Presença • ${nameEvent}`);
    }
  }, [props.idEvent]);
  
  const init = async () => {
    try {
      setIsRunning(true);
      setReadOnly(authenticationService.isReadOnly());
      const { data } = await api.get(`/events/${idEvent}/presence/open`);
      
      setPresenceOpen((data.success && data.item?.presenceList) ? true : false);

      setPresenceOpened(data.item);
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });
    } finally {
      setIsRunning(false);
    }
  }

  const handlePresence = async () => {
    setIsRunning(true);
    try {
      await api.post(`/events/${idEvent}/presence`);
      setConfirmeOpen(false);
      
      navigate(`/eventos/${idEvent}/em-andamento`);
    } catch (e: any) {
      e.messages?.forEach((m: string) => { toast.error(m, toastOptions); });
    } finally {
      setIsRunning(false);
    }
  }

  return (<>
    <div className="uk-card uk-card-warning uk-card-hover">
      {!isRunning && hasPresenceOpen && 
        <div className="uk-card-header">
          <div className="uk-grid-small uk-flex-middle" uk-grid="true">
            <div className="uk-width-expand">
              <h3 className="uk-margin-remove-bottom">{label}</h3>
            </div>
          </div>
        </div>
      }
      <div className="uk-card-body">
        {!hasPresenceOpen && (
          <div className="uk-inline-clip uk-transition-toggle uk-flex uk-flex-column uk-flex-middle uk-flex-center">
            <div className="uk-button uk-padding-remove"
              onClick={() => {if (!isRunning && !hasPresenceOpen && !isReadOnly) setConfirmeOpen(true);}}
            >
              <div className="uk-transition-scale-up uk-transition-opaque uk-flex uk-flex-column">
                {isRunning && <div className="uk-margin-small-left" uk-spinner="true; ratio:2"></div>}
                
                {!isRunning && isReadOnly && <span>{label}</span>}
                
                {!hasPresenceOpen && !isRunning && <>
                  {isReadOnly && <span>Não iniciada</span>}
                  {!isReadOnly && <><span uk-icon="icon: plus; ratio: 2" /><span>Lista de Presença</span></>}
                </>}
              </div>
            </div>
          </div>
        )}
        {hasPresenceOpen && !isRunning && (
          <div className="uk-padding-remove">
            <h4 className="uk-margin-remove-bottom uk-flex uk-flex-middle">
              <span uk-icon="icon: clock; ratio: 1"></span>
              <span className="uk-margin-left">
                Iniciada: {displayDateTime(presenceOpened?.presenceList.createdDate)}
              </span>
            </h4>
            <h5 className="uk-margin-medium-top">{presenceOpened?.qtyPeople} pessoa(s) presente(s)</h5>
          </div>
        )}
      </div>
      {!isRunning && hasPresenceOpen &&
        <div className="uk-card-footer uk-padding-remove-top">
          <Link to={`/eventos/${idEvent}/em-andamento`}>Acessar <span uk-icon="arrow-right"></span></Link>
        </div>
      }
    </div>          
    <DialogConfirm
      open={openConfirm}
      text={[
        `Deseja abrir uma nova lista de presença neste evento?`,
        `Se sim clique em [Confirmar], se não clique em [Cancelar] e tente novamente.`
      ]}
      title="Nova Lista"
      handleConfirmation={handlePresence}
      afterClose={() => {setConfirmeOpen(false);}}                
    />
  </>);
}
